import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import * as dayjs from 'dayjs';
import { CapacityHour } from 'src/app/models/capacity.model';
import { RequestHeaderModel } from 'src/app/models/request-header.model';
import { RequestLineModel } from 'src/app/models/request-line.model';
import { MenuCategory, MenuItem, MenuItemBook, MenuItemBookDetail, MenuSection } from 'src/app/models/rich-data.model';
import { SalesHeader, SalesLine } from 'src/app/models/sales-header.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { RequestService } from 'src/app/services/request.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { MenuItemBlockOutModel } from '../../../models/menu-item-block-out.model';

@Component({
  selector: 'app-reservation',
  templateUrl: './reservation.component.html',
  styleUrls: ['./reservation.component.scss']
})
export class ReservationComponent implements OnInit {

  @Input() menuItem: MenuItem;
  @Input() menuSection: MenuSection;
  @Input() menuCategory: MenuCategory;

  selectedBook: MenuItemBook = null;
  selectedDetail: MenuItemBookDetail = null;
  selectedHour: CapacityHour = null;

  bookPax: number = null;
  childPax = 0;
  infantPax = 0;
  paxMaxLimit = 0;
  paxMinLimit = 0;
  paxCardCount = 10;
  step = 0;
  duration = 0;

  bookDay: string = null;
  date: string = null;
  bookTime: string = null;
  startTime: string = null;
  reservationDate: string = null;

  reservationHours: CapacityHour[] = [];

  today: Date = new Date();
  cantSuitable = false;
  dayNotFound = false;
  showDropdown = true;
  processing = false;
  bookableCount = 0;

  blocks: MenuItemBlockOutModel[] = [];

  constructor(
    private requestServ: RequestService,
    public dataServ: DataService,
    public authServ: AuthService,
    private mdlctrl: ModalController,
    private caption: CaptionPipe,
    private router: Router,
    public cartServ: CartService,
    private reservationServ: ReservationService,
    private translator: GetTranslationService
  ) {
  }

  ngOnInit() {

    this.authServ.control();

    if (this.menuItem.show_booking_date) {
      this.menuItem.menu_item_books = this.menuItem.menu_item_books.map(x => {
        x.menu_item_book_details = x.menu_item_book_details.filter(y => {

          y.start_time = new Date(y.start_time);
          y.end_time = new Date(y.end_time);

          if (dayjs(y.start_time).format('YYYY-MM-DD') === dayjs(y.end_time).format('YYYY-MM-DD')) {
            if (new Date(y.start_time) > new Date()) {
              return true;

            } else {
              return false;
            }
          } else {
            if (new Date(y.end_time) > new Date()) {
              return true;
            } else {
              return false;
            }
          }
        }
        );
        return x;
      }
      );
    }
    ;


    if (this.menuItem.menu_item_books && this.menuItem.menu_item_books.length === 1
      && this.menuItem.menu_item_books[0].menu_item_book_details
      && this.menuItem.menu_item_books[0].menu_item_book_details.length === 1) {


      this.selectedBook = this.menuItem.menu_item_books[0];
      this.selectedDetail = this.menuItem.menu_item_books[0].menu_item_book_details[0];

      this.updateSelect();
      this.showDropdown = false;
    } else if ((this.menuItem.menu_item_books && this.menuItem.menu_item_books.length == 0)) {
      this.cantSuitable = true;
    }


  }

  minimumAdvanceControl() {

    if (this.selectedBook.minimum_time_in_advance_type === 'hour') {
      let ADVANCEVALUE = this.selectedBook.minimum_time_in_advance_value * 60;
      this.today = new Date(this.today.getTime() + ADVANCEVALUE * 60000);
    } else if (this.selectedBook.minimum_time_in_advance_type === 'day') {
      let ADVANCEVALUE = this.selectedBook.minimum_time_in_advance_value * 1440;
      let DAY = Math.round(ADVANCEVALUE / 1440);
      this.today.setDate(this.today.getDate() + DAY);
    }

  }

  async addStep() {
    this.step++;

    if (this.step === 2) {
      if (!this.dataServ.menuItem.fix_menu) {
        this.step++;
      }

      if (!this.bookPax) {
        this.bookPax = 1;
      }
    }

    if (this.step === 3) {
      this.duration = this.cartServ.cart.reduce((acc, cur) => acc + (cur.size.reservation_block_time_type === 'hour'
        ? cur.size.reservation_block_time_value * 60
        : cur.size.reservation_block_time_value), 0);

      this.reservationHours = await this.reservationServ.getCapacityHours(
        this.selectedDetail,
        new Date(this.reservationDate),
        +this.bookPax,
        this.duration
      );
    }
  }

  async close() {
    await this.mdlctrl.dismiss();
  }

  updateSelect() {

    this.selectedBook = this.menuItem.menu_item_books.find(x => x.id === this.selectedDetail.menu_item_book_id);

    this.paxMaxLimit = this.selectedDetail.maximum_number_of_people_per_reservation;
    this.paxMinLimit = this.selectedDetail.minimum_number_of_people_per_reservation;

    if (this.paxMaxLimit && this.paxMinLimit) {

      this.paxCardCount = this.paxMaxLimit - this.paxMinLimit + 1;

    } else if (this.paxMaxLimit && !this.paxMinLimit) {

      this.paxCardCount = this.paxMaxLimit;

    } else if (!this.paxMaxLimit && this.paxMinLimit) {

      this.paxCardCount = 10;

    } else {
      this.paxCardCount = 10;
    }

    this.minimumAdvanceControl();

    if (this.selectedBook) {


      let HTML = document.getElementsByClassName("day-cards");
      setTimeout(() => {
        if (HTML.length == 0) {
          this.dayNotFound = true;
        } else {
          this.dayNotFound = false;
        }
      }, 100);
    }

    const bookIndex = this.menuItem.menu_item_book_details.findIndex(x => x.id === this.selectedDetail.id);
    const blocks: MenuItemBlockOutModel[] = this.menuItem.menu_item_book_details[bookIndex].block_outs;
    this.blocks.push(...blocks);

  }

  async send(note: string) {

    this.processing = true;

    const ORDERDATE = (dayjs.tz(`${this.reservationDate}T${this.bookTime}`, this.dataServ.rData.time_zone)).toISOString();

    if (!this.authServ.profile) {
      await this.authServ.getMe();
    }

    const REQ = new RequestHeaderModel(
      this.authServ.profile, note, 'Facility Reservation',
      this.caption.transform(this.menuSection.title, this.dataServ.rData.hotel_language || 'tr'), this.menuItem,
      this.caption.transform(this.menuSection.title, this.dataServ.rData.hotel_language || 'tr'),
      this.caption.transform(this.menuCategory.title, this.dataServ.rData.hotel_language || 'tr'),
      this.caption.transform(this.menuItem.name, this.dataServ.rData.hotel_language || 'tr'), ORDERDATE, this.dataServ.menuItem.form_fields
    );

    REQ.menu_item_capacity_id = this.selectedHour.capacityIds[0];
    REQ.menu_item_book_detail_id = this.selectedHour.menu_item_book_detail_id;
    REQ.start_date = REQ.order_date;
    REQ.end_date = dayjs(REQ.order_date).add(this.duration, 'minute').toISOString();

    const ADULT = await this.translator.getTranslate('Adult');

    const LINE = new RequestLineModel(
      1, REQ, 'Profile', `${this.authServ.profile.first_name} ${this.authServ.profile.last_name}`,
      this.caption.transform(this.menuItem.name, this.dataServ.rData.hotel_language || 'tr'),
      this.caption.transform(this.menuItem.description, this.dataServ.rData.hotel_language || 'tr'),
      this.bookPax, this.selectedDetail.activate_offer ? this.selectedDetail.offer_price : this.selectedDetail.price, this.selectedDetail.currency_code, ADULT
    );

    REQ.requestlines.push(LINE);

    // const CHILDTEXT = await this.translator.getTranslate('Child');
    const CHILDTEXT = 'Child'

    if (this.childPax > 0) {
      const CHILD = new RequestLineModel(
        2, REQ, 'Profile', `${CHILDTEXT} (${this.dataServ.rData.child_age_range})`,
        this.caption.transform(this.menuItem.name, this.dataServ.rData.hotel_language || 'tr'),
        this.caption.transform(this.menuItem.description, this.dataServ.rData.hotel_language || 'tr'),
        this.childPax, this.selectedDetail.activate_offer ? this.selectedDetail.offer_price : this.selectedDetail.child_price, this.selectedDetail.currency_code, CHILDTEXT
      );

      REQ.requestlines.push(CHILD);
    }

    // const INFANTTEXT = await this.translator.getTranslate('Free Child');
    const INFANTTEXT = 'Infant';


    if (this.infantPax > 0) {
      const CHILD = new RequestLineModel(
        2, REQ, 'Profile', `${CHILDTEXT} (${this.dataServ.rData.baby_age_range})`,
        this.caption.transform(this.menuItem.name, this.dataServ.rData.hotel_language || 'tr'),
        this.caption.transform(this.menuItem.description, this.dataServ.rData.hotel_language || 'tr'),
        this.infantPax, 0, this.selectedDetail.currency_code,
        INFANTTEXT
      );

      REQ.requestlines.push(CHILD);
    }


    if (this.cartServ.totalCount > 0) {
      this.cartServ.cart = [...new Set(this.cartServ.cart)];

      this.cartServ.cart.forEach((item, index) => {
        if (item && item.size.quantity > 0) {
          const rLine: RequestLineModel = new RequestLineModel(
            index + 1, REQ, 'Menu Item Catalog',
            this.caption.transform(item.product.name, this.dataServ.rData.hotel_language || 'tr'),
            this.caption.transform(item.product.name, this.dataServ.rData.hotel_language || 'tr'),
            this.caption.transform(item.product.description, this.dataServ.rData.hotel_language || 'tr'),
            item.size.quantity, item.basePrice, item.size.currency_code,
            this.caption.transform(item.size.size, this.dataServ.rData.hotel_language || 'tr')
          );

          REQ.requestlines.push(rLine);
        }
      });
    }

    REQ.total_amount = REQ.requestlines.reduce((a, b) => a + (b.amount || 0), 0);

    try {

      if (this.dataServ.menuItem.mobile_payment && this.authServ.isLogged && REQ.total_amount > 0) {
        const PAYMENTTYPE = await this.requestServ.getPaymentProvider();


        //PAYMENT TİPİ GPE PAY İSE
        if (PAYMENTTYPE.name === 'GPEPay') {

          REQ.payment_type = 'Online';
          const REQUEST = await this.requestServ.postrequest([REQ]);

          // SALES HEADER OLUŞTURULUYOR

          const SALESHEADER = new SalesHeader(REQUEST[0], this.authServ.profile, this.dataServ.rData);
          SALESHEADER.currency = REQUEST[0].requestlines[0].currency_code;
          SALESHEADER.payment_method_code = 'CreditCard';
          SALESHEADER.invoice_discount_calculation = 'None';


          for (const [INDEX, ITEM] of REQUEST[0].requestlines.entries()) {

            // const CARTITEM = this.carcart.find(x => x.size.menu_item_catalog_id === ITEM.request_type_id);
            const CARTITEM = this.cartServ.cart.find(x => x.size.menu_item_catalog_id === ITEM.request_type_id);

            let discount: {
              type: 'None' | '%' | 'LineAmount';
              discountAmount: number;
              basePrice: number;
              invoiceDiscount: number;
            } = null;

            if (CARTITEM) {
              discount = {
                type: CARTITEM.discountType || 'None',
                discountAmount: CARTITEM.discountAmount,
                basePrice: CARTITEM.basePrice * CARTITEM.size.quantity,
                invoiceDiscount: 0
              };
            } else {
              discount = {
                type: 'None',
                discountAmount: 0,
                basePrice: ITEM.amount,
                invoiceDiscount: 0
              };
            }
            const SALESLINE = new SalesLine(REQUEST[0], ITEM, this.authServ.profile, INDEX + 1, discount, 0);
            SALESLINE.type = 'Item';
            SALESHEADER.sales_lines.push(SALESLINE);
          }

          SALESHEADER.sales_lines.forEach(line => {
            SALESHEADER.invoice_amount += line.line_amount;
          });

          SALESHEADER.redirect_success_url = window.location.origin + '/payment-successfull'

          SALESHEADER.redirect_un_success_url = window.location.origin + '/payment-failed'

          const IFRAMEURLBASE64 = await this.requestServ.sendSale(SALESHEADER);
          const IFRAMEURL = atob(IFRAMEURLBASE64.pay_url);
          window.location.href = IFRAMEURL;


          const URL = this.router.url.split('/');
          URL.shift();


          const routeUrl = '/' + URL[0];
          this.router.navigateByUrl(routeUrl);
          this.close();

        }

      } else {
        await this.requestServ.postrequest([REQ]);
        this.cartServ.clearCart();
        this.close();
        const URL = this.router.url.split('/');

        URL.shift();

        const routeUrl = '/' + URL[0];
        this.router.navigateByUrl(routeUrl);
      }
    } catch {
    }
    this.processing = false;
  }

  isBlockOut(i: number) {
    const date = dayjs(this.today).add(i, 'day');
    return !this.blocks.find(x => new Date(x.start_date).getDate() === date.date() && new Date(x.start_date).getMonth() === date.month() && new Date(x.start_date).getFullYear() === date.year());
  }
}
